'use strict';

var i18n = require('ofs/i18n');
var gettext = i18n.gettext;

var React = require('react');
var Immutable = require('immutable');
var PureRenderMixin = require('react').addons.PureRenderMixin;
var Fluxxor = require("fluxxor");
var FluxMixin = Fluxxor.FluxMixin(React);
var StoreWatchMixin = Fluxxor.StoreWatchMixin;
var tracker = require('ofs/utils/Tracker/Tracker');
var ReactForms = require('react-forms');
var Form = ReactForms.Form;

var http = require('http');
http.post = require('http-post');

var settings = require('ofs/settings');
var cities = settings.cities;

var buildSchema = require('./schema');

var messages = {
  HEADING: gettext('How can we help?'),
  SUBMITTING: gettext('Submitting…'),
  SUCCESS_HEADING: gettext('Thank you for your enquiry'),
  SUCCESS_MESSAGE: gettext('We\'ll get back to you soon.'),
  ERROR_HEADING: gettext('Something went wrong'),
  ERROR_DEFAULT_MESSAGE: gettext('There was a problem with your submission.'),
  FOOTER_PHONE_SEARCH: gettext('Call reservations on %(phone_number)s'),
  FOOTER_PHONE_CITY: gettext('Call our %(city)s team on %(phone_number)s'),
  FOOTER_PHONE_GLOBAL: gettext('Call our team on %(phone_number)s'),
  FOOTER_EMAIL: gettext('Email <a href="%(email_url)s">%(email)s</a>'),
  SUBMIT_BUTTON: gettext('Send enquiry'),
  REQUIRED_FIELD: gettext('* indicates a required field')
};


var topicFooters = {
  'search_enquiry': require('../mappings/search').Footer,
  'booking_enquiry': require('../mappings/booking').Footer,
  'host_enquiry': require('../mappings/host').Footer,
  'general_enquiry': require('../mappings/general').Footer
};


var OFSForm = React.createClass({
  mixins: [PureRenderMixin],

  render: function() {
    var {children, ...props} = this.props;

    return (
      <form {...props}>
        {children}
        <div className="ofs-EnquiryForm__Actions">
          <button className="ofs-Button bdd-enquire-modal-button-submit">{messages.SUBMIT_BUTTON}</button>
          <div className="ofs-Form__HelpText rf-Required">{messages.REQUIRED_FIELD}</div>
        </div>
      </form>
    );
  }
});


var ContactForm = React.createClass({
  mixins: [PureRenderMixin, FluxMixin, StoreWatchMixin("EnquiryStore", "GuestStore")],

  getInitialState: function() {
    return {
      status: 'default',
      topic: 'search_enquiry',
      cityCode: this.getFlux().store('EnquiryStore').state.get('cityCode', 'LON'),
      contactPreference: 'email'
    };
  },

  getStateFromFlux: function() {
    var flux = this.getFlux();
    var enquiryStoreState = flux.store('EnquiryStore').state;
    var guestStoreState = flux.store('GuestStore').state;
    var defaultValues = enquiryStoreState.merge(guestStoreState);

    var topic = 'search_enquiry';
    var contactPreference = 'email';

    if (this.state) {
      topic = this.state.topic;
      contactPreference = this.state.contactPreference;
    }
    var schema = buildSchema(topic, contactPreference, defaultValues);

    return { defaultValues, schema };
  },

  onUpdate: function(value, validation, update) {
    var field = Immutable.List(update).last();
    var changedValue = value.getIn(update);
    var newState = {};

    if (field === 'enquiry_option') {
      newState['topic'] = changedValue;
      newState['schema'] = buildSchema(changedValue, this.state.contactPreference, this.state.defaultValues);
    } else if (field === 'contact_preference') {
      newState['contactPreference'] = changedValue;
      newState['schema'] = buildSchema(this.state.topic, changedValue, this.state.defaultValues);
    } else if (field === 'location') {
      newState['cityCode'] = changedValue;
    }
    this.setState(newState);
  },

  onSubmit: function(event) {
    const {source} = this.props;
    var data;
    event.preventDefault();
    this.refs.form.makeDirty();

    if (!this.refs.form.isValid()) {
      const invalidFields = Object.keys(this.refs.form.getValidation().children.toJS());
      tracker.enquiryValidationError(source, invalidFields);
      return;
    }

    data = this.refs.form.getValue().toJSON();

    tracker.submitEnquiry(source, data);
    http.post(settings.urls.enquiry, data, function(response) {
      if (response.statusCode !== 200) {
        this.setState({
          status: 'error',
          error: null
        });
      } else {
        tracker.confirmedEnquiry(source);
        this.getFlux().actions.tracking.sendEnquiryEvent({source: source, eventType: 'general-enquiry'});
        this.setState({status: 'success'});
      }
    }.bind(this)).on('error', function(e) {
      this.setState({
        status: 'error',
        error: e.message
      });
    }.bind(this));

    this.setState({status: 'submitting'});
  },

  render: function() {
    var cityCode = this.state.cityCode;
    var cityName = null;

    if (cityCode !== "" && cityCode !== null) {
      cityName = cities[cityCode].name;
    }
    var status = this.state.status;
    var Footer = topicFooters[this.state.topic];

    return (
      <section className="ofs-EnquiryForm">
        <div className="ofs-EnquiryForm__Content">
          <h2 className="ofs-EnquiryForm__Title">{messages.HEADING}</h2>
          {status === 'default' &&
            <Form component={OFSForm}
              className="ofs-Form -form--condensed"
              ref="form"
              method="post"
              action="."
              onUpdate={this.onUpdate}
              schema={this.state.schema}
              onSubmit={this.onSubmit} />}
          {status === 'submitting' &&
            <div className="ofs-EnquiryForm__Message">
              <h3>{messages.SUBMITTING}</h3>
            </div>}
          {status === 'success' &&
            <div className="ofs-EnquiryForm__Message">
              <h3>{messages.SUCCESS_HEADING}</h3>
              <p>{messages.SUCCESS_MESSAGE}</p>
            </div>}
          {status === 'error' &&
            <div className="ofs-EnquiryForm__Message">
              <h3>{messages.ERROR_HEADING}</h3>
              <p>{this.state.message || messages.ERROR_DEFAULT_MESSAGE}</p>
            </div>}
        </div>
        <Footer cityCode={cityCode} cityName={cityName} />
      </section>
    );
  }
});


module.exports = ContactForm;



/** WEBPACK FOOTER **
 ** ./static/js/onefinestay/components/contact/generic/component.jsx
 **/